// 기존 claimStatusTypes는 다국어 처리 안되어있고, 기존 컴포넌트들이 의존중인 상황. 그래서 새로 만듬
export default [
  {value: 'CANCEL_NO_REFUND', name: 'CLAIM_COMMON_CANCEL_NO_REFUND'},
  {value: 'CANCEL_REQUEST', name: 'CLAIM_COMMON_CANCEL_REQUEST'},
  {value: 'CANCEL_PROC_REQUEST_REFUND', name: 'CLAIM_COMMON_CANCEL_PROC_REQUEST_REFUND'},
  {value: 'CANCEL_PROC_WAITING_REFUND', name: 'CLAIM_COMMON_CANCEL_PROC_WAITING_REFUND'},
  {value: 'CANCEL_DONE', name: 'CLAIM_COMMON_CANCEL_DONE'},
  {value: 'RETURN_NO_REFUND', name: 'CLAIM_COMMON_RETURN_NO_REFUND'},
  {value: 'RETURN_REQUEST', name: 'CLAIM_COMMON_RETURN_REQUEST'},
  {value: 'RETURN_REJECT_REQUEST', name: 'CLAIM_COMMON_RETURN_REJECT_REQUEST'},
  {value: 'RETURN_PROC_BEFORE_RECEIVE', name: 'CLAIM_COMMON_RETURN_PROC_BEFORE_RECEIVE'},
  {value: 'RETURN_PROC_REQUEST_REFUND', name: 'CLAIM_COMMON_RETURN_PROC_REQUEST_REFUND'},
  {value: 'RETURN_REFUND_AMT_ADJUST_REQUESTED', name: 'CLAIM_COMMON_RETURN_REFUND_AMT_ADJUST_REQUESTED'},
  {value: 'RETURN_PROC_WAITING_REFUND', name: 'CLAIM_COMMON_RETURN_PROC_WAITING_REFUND'},
  {value: 'RETURN_DONE', name: 'CLAIM_COMMON_RETURN_DONE'},
  {value: 'EXCHANGE_REQUEST', name: 'CLAIM_COMMON_EXCHANGE_REQUEST'},
  {value: 'EXCHANGE_REJECT_REQUEST', name: 'CLAIM_COMMON_EXCHANGE_REJECT_REQUEST'},
  {value: 'EXCHANGE_PROC_BEFORE_RECEIVE', name: 'CLAIM_COMMON_EXCHANGE_PROC_BEFORE_RECEIVE'},
  {value: 'EXCHANGE_PROC_REQUEST_PAY', name: 'CLAIM_COMMON_EXCHANGE_PROC_REQUEST_PAY'},
  {value: 'EXCHANGE_PROC_WAITING_PAY', name: 'CLAIM_COMMON_EXCHANGE_PROC_WAITING_PAY'},
  {value: 'EXCHANGE_PROC_WAITING', name: 'CLAIM_COMMON_EXCHANGE_PROC_WAITING'},
  {value: 'EXCHANGE_DONE_PAY_DONE', name: 'CLAIM_COMMON_EXCHANGE_DONE_PAY_DONE'},
  {value: 'EXCHANGE_PROC_REQUEST_REFUND', name: 'CLAIM_COMMON_EXCHANGE_PROC_REQUEST_REFUND'},
  {value: 'EXCHANGE_PROC_WAITING_REFUND', name: 'CLAIM_COMMON_EXCHANGE_PROC_WAITING_REFUND'},
  {value: 'EXCHANGE_DONE_REFUND_DONE', name: 'CLAIM_COMMON_EXCHANGE_DONE_REFUND_DONE'},
  {value: 'EXCHANGE_DONE', name: 'CLAIM_COMMON_EXCHANGE_DONE'}
];
